module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_5010.fffb85dd.png";